import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { OtpPopupComponent } from 'src/app/components/otp-popup/otp-popup.component';
import { ApiService } from 'src/app/services/api/api.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { ValidationService } from 'src/app/services/validators/validation.service';
import { environment } from 'src/environments/environment';
import * as Constants from "../../../constants/constants";
import { checkTime } from 'src/app/util/Helper';
import { createIDsValidatorEstate } from 'src/app/services/validators/custom.validators';
import { NotificationService } from 'src/app/services/notification.service';
import { ExpansionPanel } from 'src/app/components/section/section.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-step2-settlor',
  templateUrl: './step2-settlor.component.html',
  styleUrls: ['./step2-settlor.component.scss']
})
export class Step2SettlorComponent implements OnInit, AfterViewInit, OnDestroy {

  checkerPath: string = `${environment.hRef}assets/fi_check.png`;
  title: string = 'Select Settlor Type.';
  subtitle: string = 'A settlor is the person or entity that intends to set up the trust and who prescribes the terms and conditions of the Trust. Please select whether you are registering as an institution or as an individual(s)';
  organizationText: string = 'Organization/Institution';
  individualText: string = 'Individual';

  sentence: string = 'Kindly ensure you have copies of the below documents required for set up:';
  point1Settlor: string = 'Copies of ID, KRA PIN of the individual settlors';
  point1Institution: string = 'Copy of Registration Certificate, KRA PIN for the Organisation';
  point2: string = ' Copies of ID, KRA PIN of the guardian(s)';
  point3: string = 'Birth certificate of the beneficiaries (if minors) OR Copy of ID and KRA (if beneficiary is above 18 years), OR Copy of Registration Certificate and KRA PIN if beneficiary is an organisation';

  formTitle: string = 'Please Enter Settlor Details.';
  formSubtitle: string = 'In the event that there is more than one settlor, please click on the \'Add Settlor\' button to enter details of other settlor(s)';
  
  formTitleAlt: string = 'Institution Settlor Details.';
  formSubtitleAlt: string = 'Please enter the institution\'s details below';
  
  titleLabel: string = 'Title';
  titleHint: string = 'Title';
  fNameLabel: string = 'First Name';
  fNameHint : string = 'First name';
  mNameLabel : string = 'Middle Name';
  mNameHint : string = 'Middle name';
  surnameLabel : string = 'Surname';
  surnameHint : string = 'Last name';
  phoneLabel : string = 'Primary Phone Number';
  emailLabel : string = 'Email Address';
  emailHint : string = 'Email address';
  genderLabel: string = 'Gender';
  genderHint: string = 'Select gender';
  nationalityLabel: string = 'Nationality';
  nationalityHint: string = 'Select nationality';
  countryLabel: string = 'Country of Residence';
  countryHint: string = 'Select country';
  countyLabel: string = 'County';
  countyHint: string = 'Select county';

  idLabel: string = 'ID/Passport Number';
  idHint: string = 'Enter ID or Passport Number';
  kraPinLabel: string = 'KRA PIN';
  kraPinHint: string = 'Enter KRA PIN';
  occupationLabel: string = 'Occupation';
  occupationHint: string = 'Enter Occupation';
  addressLabel: string = 'Physical Address';
  addressHint: string = 'Enter Physical address';
  idFileLabel: string = 'Upload copy of ID (front + back) / Passport';
  kraFileLabel: string = 'Upload KRA PIN';
  addSettlorText: string = '+  Add Another Settlor';
  removeSettlorText: string = 'Remove Settlor';

  isSettlorOrganization: boolean = true;
  settlorFormVisible: boolean = false;

  requiredFieldString: string = 'Required field';
  invalidDocString: string = 'Please attach a valid document';

  currentRecord: any;

  loading: boolean = false;
  loadingText: string = 'Requesting OTP';
  buttonDisabled: boolean = false;

  continueWithOneSettler: boolean = false;

  loadingRemove: boolean = false;
  currentIndex: number = 0;
  removeButtonText: string = 'Remove Settlor';

  addButtonText: string = 'Verify to add New Settler';
  addDesceased: boolean = false;

  addText: string = 'Settlor details saved';
  updateText: string = 'Settlor details updated';

  formErrors: { [key: string]: string } = {
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Phone: '',
    Email: '',
    Gender: '',
    Nationality: '',
    County: '',
    IDNo: '',
    KraPin: '',
    Occupation: '',
    Address: '',
    City: '',
    IDNoImage: '',
    KraPinImage: '',
    InstitutionName: '',
    BusinessNature: '',
  };

  validationMessages: { [key: string]: {} } = {
    FirstName: { required: this.requiredFieldString },
    MiddleName: { required: this.requiredFieldString },
    LastName: { required: this.requiredFieldString },
    Phone: { required: this.requiredFieldString, pattern:'Invalid phone number', exist: 'This number is tied to an existing settlor' },
    Email: { required: this.requiredFieldString, email: "Invalid email address", exist: 'This email is tied to an existing settlor' },
    Gender: { required: this.requiredFieldString },
    Nationality: { required: this.requiredFieldString },
    County: { required: this.requiredFieldString },
    IDNo:  { required: this.requiredFieldString, min:'Invalid ID or Passport number', exist: 'This ID is tied to an existing settlor' },
    KraPin: { required: this.requiredFieldString, pattern:'Invalid KRA PIN', exist: 'This PIN is tied to an existing settlor' },
    Occupation: { required: this.requiredFieldString },
    Address: { required: this.requiredFieldString },
    City: { required: this.requiredFieldString },
    IDNoImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
    KraPinImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
    InstitutionName: { required: this.requiredFieldString },
    BusinessNature: { required: this.requiredFieldString },
  };

  // Institution settlor form
  institutionForm = this._formBuilder.group({
  }) as FormGroup & { [key: string]: AbstractControl };

  // Individual settlor form
  individualForm = this._formBuilder.group({
  }) as FormGroup & { [key: string]: AbstractControl };

  iSwear = new FormControl(false);

  individualPanels: ExpansionPanel[][] = [];
  institutionPanels: ExpansionPanel[][] = [];
  panelsInitialized: boolean = false;

  private formChangesSubscription: Subscription[] = [];


  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly notificationService: NotificationService,
    private readonly tabControlService: TabControlService,
    private readonly validationService: ValidationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly apiService: ApiService
  ) {
  }

  ngAfterViewInit(): void {
    this.populateForm();
  }

  ngOnInit(): void {
    if (this.tabControlService.activeTab == 2) {
      this.populateData();
    }

    this.institutionForm.valueChanges.subscribe((form) => {
      this.logErrors();
    });
    this.individualForm.valueChanges.subscribe((form) => {
      this.logErrors(true);
    });
  }

  ngOnDestroy(): void {
    this.cleanupFormChangeListeners();
  }

  deathObject: any = null;

  get region(): any {
    return this.tabControlService.regionType;
  }
  get settlorType(): 0 | 1 {
    return this.tabControlService.settlorType;
  }
  get settlors(): any {
    return this.tabControlService.settlors;
  }
  get basicData(): any {
    return this.tabControlService.basicData;
  }

  get loadingTitles(): boolean {
    return this.tabControlService.loadingTitles;
  }
  get TitleOptions(): any {
    return this.tabControlService.TitleOptions;
  }

  get GenderOptions():any {
    return this.tabControlService.GenderOptions;
  }

  get loadingCountries(): boolean {
    return this.tabControlService.loadingCountries;
  }
  get CountryOptions():any {
    return this.tabControlService.CountryOptions;
  }

  get loadingCounties(): boolean {
    return this.tabControlService.loadingCounties;
  }
  get CountyOptions():any {
    return this.tabControlService.CountyOptions;
  }
  get loadingBizNature(): boolean {
    return this.tabControlService.loadingBizNature;
  }
  get BusinessNatureOptions(): any {
    return this.tabControlService.BusinessNatureOptions;
  }

  get saveProgress(): ()=> void {
    return this.tabControlService.saveProgress.bind(this);
  }

  logErrors(isIndividual?: boolean) {
    if (isIndividual) {
      this.formErrors = this.validationService.logValidationErrors(
        this.individualForm,
        this.formErrors,
        this.validationMessages
      );
    } else {
      this.formErrors = this.validationService.logValidationErrors(
        this.institutionForm,
        this.formErrors,
        this.validationMessages
      );
    }
  }

  async populateData(): Promise<void> {
    if (this.TitleOptions.length === 0) {
      this.tabControlService.loadingTitles = true;
      await this.tabControlService.getTitlesList();
      this.tabControlService.loadingTitles = false;
    }

    if (this.CountryOptions.length === 0) {
      this.tabControlService.loadingCountries = true;
      await this.tabControlService.getCountryList();
      this.tabControlService.loadingCountries = false;
    }

    if (this.CountyOptions.length === 0) {
      this.tabControlService.loadingCounties = true;
      await this.tabControlService.getCountyList();
      this.tabControlService.loadingCounties = false;
    }

    if (this.BusinessNatureOptions.length === 0) {
      this.tabControlService.loadingBizNature = true;
      await this.tabControlService.getBusinessNatOptionsList();
      this.tabControlService.loadingBizNature = false;
    }
  }

  populateForm(reset: boolean = false): void {
    if (this.settlorType == 0) this.onOptionChange(true);
    else this.onOptionChange(false);
    
    if (this.tabControlService.TrustID != null && this.settlors && this.settlors.length > 0) {
      if (this.settlors[0].SettlorID) {
        if (!this.settlorFormVisible) this.settlorFormVisible = true;
      
        const settlorsArray = this.tabControlService.settlorType == 0 ?
          this.institutionForm.get('settlors') as FormArray : this.individualForm.get('settlors') as FormArray;
        // Clear existing settlors
        while (settlorsArray.length !== 0) {
          settlorsArray.removeAt(0);
        }

        // Add settlors from storage
        this.settlors.forEach(async (settlor: any, index: number) => {
          if (index == 0) {
            if (settlor.SettlorID) {
              if (this.tabControlService.settlorType == 0) settlorsArray.push(this.createInstitutionFormGroup(settlor));
              else settlorsArray.push(this.createIndividualFormGroup(settlor));

            } else {
              await this.tabControlService.refreshRecord(2);
              if (this.tabControlService.settlorType == 0) settlorsArray.push(this.createInstitutionFormGroup());
              else settlorsArray.push(this.createIndividualFormGroup());
            }

          } else {
            if (this.tabControlService.settlorType == 0) settlorsArray.push(this.createInstitutionFormGroup(settlor));
            else settlorsArray.push(this.createIndividualFormGroup(settlor));
          }
        });

        if (this.settlors.length > 0) {
          if (this.settlorType == 1) {
            this.settlors.forEach((settlor: any, i: number) => {
              this.updateIndividualDoneStatus(i, settlor);
            });
          } else {
            this.updateInstitutionDoneStatus(this.settlors[0]);
          }
        }
      } else {
        if (reset) {
          const settlorsArray = this.tabControlService.settlorType == 0 ?
            this.institutionForm.get('settlors') as FormArray : this.individualForm.get('settlors') as FormArray;
          // Clear existing settlors
          while (settlorsArray.length !== 0) {
            settlorsArray.removeAt(0);
          }
          if (this.tabControlService.settlorType == 0) settlorsArray.push(this.createInstitutionFormGroup());
          else settlorsArray.push(this.createIndividualFormGroup());
        }
      }
    }
  }

  updateIDObject(index: number, object: any): void {
    if (!object) return;
    const currentSettlors = this.settlors;
    const latestRecord = currentSettlors[index];
    let updatedRecord = {
      ...latestRecord,
      IDNoImage: object
    };

    Object.assign(currentSettlors[index], updatedRecord);
    this.tabControlService.updateRecord(2, currentSettlors);
  }
  updateKraObject(index: number, object: any): void {
    if (!object) return;
    const currentSettlors = this.settlors;
    const latestRecord = currentSettlors[index];
    let updatedRecord = {
      ...latestRecord,
      KraPinImage: object
    };

    Object.assign(currentSettlors[index], updatedRecord);
    this.tabControlService.updateRecord(2, currentSettlors);
  }
  updateDeathObject(object: any): void {
    this.deathObject = object;
  }

  addSettlorsArray = (settlor: any = null) => {
    if (this.settlorType == 1) {
      this.individualForm.addControl('settlors', this._formBuilder.array([
        this.createIndividualFormGroup(settlor)
      ]));
    } else {
      this.institutionForm.addControl('settlors', this._formBuilder.array([
        this.createInstitutionFormGroup(settlor)
      ]));
    }
    this.setupFormChangeListeners();
  }
  addAuthorisersArray = (authoriser: any = null) => {
    this.getSettlorFormGroup()?.addControl('Authorisers', this._formBuilder.array([
      this.createAuthorisersGroup(authoriser)
    ]));
  }

  createInstitutionFormGroup(settlor: any = null): FormGroup {
    let form: FormGroup;

    const PrimaryAuthoriser = {
      Title: this.basicData.Title || '',
      FirstName: this.basicData.FirstName || '',
      MiddleName: this.basicData.MiddleName || '',
      LastName: this.basicData.LastName || '',
      Phone: this.basicData.Phone || '',
      Email: this.basicData.Email || ''
    };

    const settlorsArray = this.getSettlors();
    if (settlor) {
      let currentSettlors = this.settlors;
      let authorisers: any[] = [
        { // init from basic data
          ...PrimaryAuthoriser,
          verified: true
        }
      ];
      
      if (settlor.Authorisers) {
        // check if this array already contains PrimaryAuthoriser (should be first element):
        const first = settlor.Authorisers[0];
        const isPrimaryPresent = first &&
          first.FirstName === PrimaryAuthoriser.FirstName &&
          first.LastName === PrimaryAuthoriser.LastName &&
          first.Phone === PrimaryAuthoriser.Phone &&
          first.Email === PrimaryAuthoriser.Email;
        if (isPrimaryPresent) {
          authorisers = [...settlor.Authorisers];
        } else {
          authorisers = [PrimaryAuthoriser, ...settlor.Authorisers];
        }
      }
      
      const updatedSettlor = {
        ...settlor,
        Authorisers: authorisers,
      };
      
      Object.assign(currentSettlors[0], updatedSettlor);
      this.tabControlService.updateRecord(2, currentSettlors);

      form = this._formBuilder.group({        
        InstitutionName: [`${settlor.InstitutionName || ''}`, Validators.required],
        BusinessNature: [`${settlor.BusinessNature || ''}`, Validators.required],
        Phone: [`${settlor.Phone || ''}`, Validators.required],
        Email: [`${settlor.Email || ''}`, [Validators.required, Validators.email]],
        Address: [`${settlor.Address || ''}`, Validators.required],
        
        IDNoImage: [],
        KraPinImage: [],

        Authorisers: this._formBuilder.array(
          authorisers.map(a => this.createAuthorisersGroup(a))
        ),

        Principal: this._formBuilder.group({
          FirstName: [],
          MiddleName: [''],
          LastName: [''],
          DeathCertImage: [],
        }),
      });

      if (settlor.IDNoImage) {
        if (settlor.IDNoImage.stringValue && settlor.IDNoImage.stringValue.length > 0) {
          form.get('IDNoImage')?.setValue(settlor.IDNoImage.stringValue);
        }
      }
      if (settlor.KraPinImage) {
        if (settlor.KraPinImage.stringValue && settlor.KraPinImage.stringValue.length > 0) {
          form.get('KraPinImage')?.setValue(settlor.KraPinImage.stringValue);
        }
      }
        
      currentSettlors = this.tabControlService.settlors;

      if (settlor.Principal) {
        if (settlor.Principal.DeathCertImage) {
          if (settlor.Principal.DeathCertImage.stringValue && settlor.Principal.DeathCertImage.stringValue.length > 0) {
            form.get('Principal')?.get('DeathCertImage')?.setValue(settlor.Principal.DeathCertImage.stringValue);
          }
          this.updateDeathObject(settlor.Principal.DeathCertImage);
        }
      }
      if (settlor.authDone) {
        this.validationService.addOrRemoveValidator(true, form.get('IDNoImage')!);
        this.validationService.addOrRemoveValidator(true, form.get('KraPinImage')!);
      }
      
      if (this.institutionForm && settlorsArray && settlorsArray.length > 0) {
        this.validationService.addOrRemove3Validators(
          true,
          form.get('Email')!,
          [Validators.required,
            Validators.email,
            createIDsValidatorEstate('EMAIL', this.getSettlors(), this.settlors)
          ]
        );
        this.validationService.addOrRemoveSpecificValidators(
          true,
          form.get('Phone')!,
          [Validators.required,
            createIDsValidatorEstate('TEL', this.getSettlors(), this.settlors)
          ]
        );
        this.validationService.addOrRemove3Validators(
          true,
          form.get('IDNo')!,
          [Validators.required,
            Validators.min(4),
            createIDsValidatorEstate('ID', this.getSettlors(), this.settlors)
          ]
        );
        this.validationService.addOrRemove3Validators(
          true,
          form.get('KraPin')!,
          [Validators.required,
            Validators.pattern(/^[AP]\d{9}[A-Z]$/),
            createIDsValidatorEstate('PIN', this.getSettlors(), this.settlors)
          ]
        );
      }

    } else {
      let currentSettlors = this.settlors;
      let currentRecord: any;
      let authorisers: any[] = [{ // init from basic data
        ...PrimaryAuthoriser,
        verified: true
      }];

      if (currentSettlors[0]?.Authorisers && currentSettlors[0]?.Authorisers.length > 0) {
        // check if this array already contains PrimaryAuthoriser (should be first element):
        const first = currentSettlors[0].Authorisers[0];
        const isPrimaryPresent = first &&
          first.FirstName === PrimaryAuthoriser.FirstName &&
          first.LastName === PrimaryAuthoriser.LastName &&
          first.Phone === PrimaryAuthoriser.Phone &&
          first.Email === PrimaryAuthoriser.Email;
        if (isPrimaryPresent) {
          authorisers = [...currentSettlors[0].Authorisers];
        } else {
          authorisers = [PrimaryAuthoriser, ...currentSettlors[0].Authorisers];
        }
      }

      currentRecord = {
        infoDone: false,
        authDone: false,
        docsDone: false,
        done: false,
        Authorisers: authorisers,
        IDNoImage: { stringValue: '', name: '' },
        KraPinImage: { stringValue: '', name: '' }
      };

      form = this._formBuilder.group({
        InstitutionName: ['', Validators.required],
        BusinessNature: ['', Validators.required],
        Phone: [``, Validators.required],
        Email: [``, [Validators.required, Validators.email]],
        Address: ['', Validators.required],
        
        IDNoImage: [],
        KraPinImage: [],

        Authorisers: this._formBuilder.array([
          this.createAuthorisersGroup(PrimaryAuthoriser)
        ]),

        Principal: this._formBuilder.group({
          FirstName: [],
          MiddleName: [''],
          LastName: [''],
          DeathCertImage: [],
        }),
      });
        
  if (this.institutionForm && settlorsArray && settlorsArray.length > 0) {
        currentSettlors.push(currentRecord);
      } else {
        if (this.settlors && this.settlors.length > 0 && !this.settlors[0].SettlorID) { // first settlor wasn't captured!
          this.tabControlService.refreshRecord(2);
        }
        currentSettlors = this.settlors; // update current settlors var
        if (this.settlors.length == 0 || !this.settlors[0]?.SettlorID) {
          currentSettlors.push(currentRecord); 
        }
      }
      this.tabControlService.updateRecord(2, currentSettlors);
    }

    form.get('FirstName')?.clearValidators();
    form.get('LastName')?.clearValidators();
    form.get('Gender')?.clearValidators();
    form.get('Nationality')?.clearValidators();
    form.get('Country')?.clearValidators();
    form.get('IDNo')?.clearValidators();
    form.get('KraPin')?.clearValidators();
    
    form.get('Title')?.setValue('');
    form.get('FirstName')?.setValue('');
    form.get('MiddleName')?.setValue('');
    form.get('LastName')?.setValue('');
    form.get('Nationality')?.setValue('');
    form.get('Country')?.setValue('');
      
    form.updateValueAndValidity();

    return form;
  };

  createIndividualFormGroup(settlor: any = null): FormGroup {
    let form: FormGroup;

    const settlorsArray = this.getSettlors();
    if (settlor) {
      form = this._formBuilder.group({
        Title: [`${settlor.Title || ''}`],
        FirstName: [`${settlor.FirstName || ''}`, Validators.required],
        MiddleName: [`${settlor.MiddleName || ''}`,],
        LastName: [`${settlor.LastName || ''}`, Validators.required],
        Phone: [`${settlor.Phone || ''}`, Validators.required],
        Email: [`${settlor.Email || ''}`, [Validators.required, Validators.email]],
        Address: [`${settlor.Address || ''}`, Validators.required],
        City: [`${settlor.City || ''}`],
        Gender: [`${settlor.Gender || ''}`, Validators.required],
        Nationality: [`${settlor.Nationality || ''}`, Validators.required],
        Country: [`${settlor.Country || ''}`, Validators.required],
        County: [`${settlor.County || ''}`],
        IDNo: [`${settlor.IDNo || ''}`, [Validators.required, Validators.min(4)]],
        KraPin: [`${settlor.KraPin || ''}`, [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/)]],
        Occupation: [`${settlor.Occupation || ''}`],
        
        IDNoImage: [],
        KraPinImage: [],
      });

      if (settlor.IDNoImage) {
        if (settlor.IDNoImage.stringValue && settlor.IDNoImage.stringValue.length > 0) {
          form.get('IDNoImage')?.setValue(settlor.IDNoImage.stringValue);
        }
      }
      if (settlor.KraPinImage) {
        if (settlor.KraPinImage.stringValue && settlor.KraPinImage.stringValue.length > 0) {
          form.get('KraPinImage')?.setValue(settlor.KraPinImage.stringValue);
        }
      }
      if (settlor.verified) {
        this.validationService.addOrRemoveValidator(true, form.get('IDNoImage')!);
        this.validationService.addOrRemoveValidator(true, form.get('KraPinImage')!);
      }
      
      if (this.individualForm && settlorsArray && settlorsArray.length > 0) {
        this.validationService.addOrRemove3Validators(
          true,
          form.get('Email')!,
          [Validators.required,
            Validators.email,
            createIDsValidatorEstate('EMAIL', this.getSettlors(), this.settlors)
          ]
        );
        this.validationService.addOrRemoveSpecificValidators(
          true,
          form.get('Phone')!,
          [Validators.required,
            createIDsValidatorEstate('TEL', this.getSettlors(), this.settlors)
          ]
        );
        this.validationService.addOrRemove3Validators(
          true,
          form.get('IDNo')!,
          [Validators.required,
            Validators.min(4),
            createIDsValidatorEstate('ID', this.getSettlors(), this.settlors)
          ]
        );
        this.validationService.addOrRemove3Validators(
          true,
          form.get('KraPin')!,
          [Validators.required,
            Validators.pattern(/^[AP]\d{9}[A-Z]$/),
            createIDsValidatorEstate('PIN', this.getSettlors(), this.settlors)
          ]
        );
      }

      // Prevent editing IDNo after autofill
      if (settlor.Category?.toLowerCase().includes('primary')) {
        if (form.get('IDNo')?.value && form.get('IDNo')?.value.length > 2) form.get('IDNo')?.disable();
        if (form.get('FirstName')?.value && form.get('FirstName')?.value.length > 2) form.get('FirstName')?.disable();
        if (form.get('LastName')?.value && form.get('LastName')?.value.length > 2) form.get('LastName')?.disable();
        if (form.get('MiddleName')?.value && form.get('MiddleName')?.value.length > 2) form.get('MiddleName')?.disable();
        if (form.get('Phone')?.value && form.get('Phone')?.value.length > 2) form.get('Phone')?.disable();
        if (form.get('Email')?.value && form.get('Email')?.value.length > 2) form.get('Email')?.disable();
      }
    } else {
      let currentSettlors = this.settlors;
      let currentRecord: any = { 
        verified: false, 
        done: false,
        IDNoImage: { stringValue: '', name: '' },
        KraPinImage: { stringValue: '', name: '' }
      };
        
      if (this.individualForm && settlorsArray && settlorsArray.length > 0) {
        currentSettlors.push(currentRecord);
        this.tabControlService.updateRecord(2, currentSettlors);
  
        form = this._formBuilder.group({
          Title: [''],
          FirstName: ['', Validators.required],
          MiddleName: [''],
          LastName: ['', Validators.required],
          Phone: ['', [Validators.required, createIDsValidatorEstate('TEL', this.getSettlors(), this.settlors)]],
          Email: ['', [Validators.required, Validators.email, createIDsValidatorEstate('EMAIL', this.getSettlors(), this.settlors) ]],
          Address: ['', Validators.required],
          City: [''],
          Gender: ['', Validators.required],
          Nationality: [ this.region === 0 ? 'KENYAN' : '', Validators.required],
          Country: [this.region === 0 ? 'KENYA' : '', Validators.required],
          County: [''],
          IDNo: ['', [Validators.required, Validators.min(4), createIDsValidatorEstate('ID', this.getSettlors(), this.settlors) ]],
          KraPin: ['', [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/), createIDsValidatorEstate('PIN', this.getSettlors(), this.settlors) ]],
          Occupation: [''],

          IDNoImage: [],
          KraPinImage: [],     
        });

      } else {
        if (this.settlors && this.settlors.length > 0 && !this.settlors[0].SettlorID) { // first settlor wasn't captured!
          this.tabControlService.refreshRecord(2);
        }

        currentSettlors = this.settlors; // update current settlors var
        currentRecord.verified = true; // First settlor is already verified

        if (this.settlors.length == 0 || !this.settlors[0]?.SettlorID) {
          currentSettlors.push(currentRecord);
          this.tabControlService.updateRecord(2, currentSettlors);  
        }

        form = this._formBuilder.group({
          Title: [`${this.tabControlService.basicData.Title || ''}`],
          FirstName: [`${this.tabControlService.basicData.FirstName || ''}`, Validators.required],
          MiddleName: [`${this.tabControlService.basicData.MiddleName || ''}`],
          LastName: [`${this.tabControlService.basicData.LastName || ''}`, Validators.required],
          Phone: [`${this.tabControlService.basicData.Phone || ''}`, Validators.required],
          Email: [`${this.tabControlService.basicData.Email || ''}`, [Validators.required, Validators.email]],
          Address: ['', Validators.required],
          City: [''],
          Gender: ['', Validators.required],
          Nationality: [this.region === 0 ? 'KENYAN' : '', Validators.required],
          Country: [this.region === 0 ? 'KENYA' : '', Validators.required],
          County: [''],
          IDNo: [`${this.tabControlService.basicData.IDNo || ''}`, [Validators.required, Validators.min(4)]],
          KraPin: ['', [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/)]],
          Occupation: [''],

          IDNoImage: [],
          KraPinImage: [],  
        });

        // Prevent editing IDNo after autofill
        if (form.get('IDNo')?.value && form.get('IDNo')?.value.length > 2) form.get('IDNo')?.disable();
        if (form.get('FirstName')?.value && form.get('FirstName')?.value.length > 2) form.get('FirstName')?.disable();
        if (form.get('LastName')?.value && form.get('LastName')?.value.length > 2) form.get('LastName')?.disable();
        if (form.get('MiddleName')?.value && form.get('MiddleName')?.value.length > 2) form.get('MiddleName')?.disable();
        if (form.get('Phone')?.value && form.get('Phone')?.value.length > 2) form.get('Phone')?.disable();
        if (form.get('Email')?.value && form.get('Email')?.value.length > 2) form.get('Email')?.disable();
      }
    }

    form.get('InstitutionName')?.clearValidators();
    form.get('BusinessNature')?.clearValidators();
    form.get('Authorisers')?.clearValidators();
    form.get('Principal')?.clearValidators();

    form.updateValueAndValidity();

    return form;
  };

  async addNewSettlor() {
    const fields = this.individualForm.get('settlors') as FormArray;
    const newFormGroup = this.createIndividualFormGroup();
    fields.push(newFormGroup);
    this.individualForm.setControl('settlors', fields);

    // Wait for view to update
    await new Promise(resolve => setTimeout(resolve));
    const newIndex = fields.length - 1;
    this.individualPanels[newIndex] = this.generatePanelsForIndividuals(newIndex);

    // Set up listeners after panels are generated
    this.setupFormChangeListenersForIndex(newIndex);
    this.cdr.detectChanges();
  }

  async removeSettlor(i:number) {
    this.currentIndex = i;
    const fields = this.individualForm.get('settlors') as FormArray;
    let currentSettlors = this.tabControlService.settlors;
    
    if (currentSettlors[i]?.SettlorID) {
      this.removeButtonText = 'Removing Settlor';
      this.loadingRemove = true;
      
      try {
        if (this.tabControlService.TrustID === null) {
          console.log('Relevant IDs not found');
        } else {
          const result = await this.tabControlService.removeRecord(
            'Settlers',
            currentSettlors[i].SettlorID,
            Number.parseInt(this.tabControlService.TrustID),
            'Settlor'
          );

          if (result === 1) {
            this.notificationService.viewToast('success', 'Settlor removed successfully');
            fields.removeAt(i);
            // Remove settlor at index
            currentSettlors.splice(i, 1);;
            this.tabControlService.updateRecord(2, currentSettlors);
          } else {
            this.notificationService.viewToast('error', 'Error removing record');
          }
        }
      } catch (error) {
        console.error(':: Error !! ', error);
      }
      this.removeButtonText = 'Remove Settlor';
      this.loadingRemove = false;
    } else {
      if (currentSettlors[i]) {
        fields.removeAt(i);
        // Remove settlor at index
        currentSettlors.splice(i, 1);
        this.tabControlService.updateRecord(2, currentSettlors);
      } else {
        fields.removeAt(i);
      }
    }

    setTimeout(()=> {
      this.generatePanelsForIndividuals(i);
      this.settlors.forEach((settlor: any, index: number) => {
        this.updateIndividualDoneStatus(index, settlor);
      });
    })
  }

  getSettlors() : FormArray {
    if (this.settlorType == 0)
      return this.institutionForm.get("settlors") as FormArray  
    else
      return this.individualForm.get("settlors") as FormArray  
  }
  getSettlorFormGroup(index: number = 0): FormGroup {
    if (this.settlorType == 0) {
      const settlors = this.institutionForm.get('settlors') as FormArray;
      return settlors?.at(0) as FormGroup;
    } else {
      const settlors = this.individualForm.get('settlors') as FormArray;
      return settlors?.at(index) as FormGroup;
    }
  }

  // AUTHORISERS (FOR INSTITUTIONAL SETTLORS)
  createAuthorisersGroup(contact?: any): FormGroup {    
    const currentSettlors = this.settlors;
    let currentRecord = currentSettlors[0];
    let currentAuthorisers: any[] =  currentRecord ? currentRecord?.Authorisers : [];
    let authForm: FormGroup;

    if (contact?.Phone && contact.Phone !== '') {
      authForm = this._formBuilder.group({
        Title: [`${contact.Title || ''}`],
        FirstName: [`${contact.FirstName || ''}`],
        MiddleName: [`${contact.MiddleName || ''}`],
        LastName: [`${contact.LastName || ''}`],
        Phone: [`${contact.Phone || ''}`],
        Email: [`${contact.Email || ''}`]
      });
    } else {
      authForm = this._formBuilder.group({
        Title: [''],
        FirstName: [''],
        MiddleName: [''],
        LastName: [''],
        Phone: [''],
        Email: ['']
      });
      
      currentAuthorisers.push({...authForm.getRawValue() , verified: false});
      currentRecord = {...currentRecord, Authorisers: currentAuthorisers};
      Object.assign(currentSettlors[0], currentRecord);
      this.tabControlService.updateRecord(2, currentSettlors);
      
      try {
        if (currentRecord.infoDone
          && this.getAuthorisers()?.length > 0
          && currentAuthorisers?.length > 0
        ) {
          authForm.get('FirstName')?.addValidators(Validators.required);
          authForm.get('LastName')?.addValidators(Validators.required);

          this.validationService.addOrRemoveSpecificValidators(
            true,
            authForm.get('Phone')!,
            [
              Validators.required,
              createIDsValidatorEstate('TEL',
                this.getAuthorisers(),
                this.settlors[0].Authorisers)
            ]
          );

          this.validationService.addOrRemove3Validators(
            true,
            authForm.get('Email')!,
            [
              Validators.required,
              Validators.email,
              createIDsValidatorEstate('EMAIL',
                this.getAuthorisers(),
                this.settlors[0].Authorisers)
            ]
          );
        }
      } catch (error) {
        if (!environment.production) console.error('createAuthorisersGroup : ', error)
      }
    }

    if (!(this.institutionForm && this.getAuthorisers()?.length > 0) ) {
      authForm.get('Title')?.disable();
      authForm.get('FirstName')?.disable();
      authForm.get('MiddleName')?.disable();
      authForm.get('LastName')?.disable();
      authForm.get('Phone')?.disable();
      authForm.get('Email')?.disable();
    }
    
    return authForm;
  };

  async addNewAuthoriser() {
    const fields: FormArray = this.getAuthorisers();
    let currentContacts = fields.getRawValue();

    if (currentContacts.length > 0) {
      const currentSettlors = this.settlors;
      let latestRecord = currentSettlors[0];

      if (latestRecord.Authorisers?.length > 0) {
        currentContacts = currentContacts.map((contact: any) => {
          let matchingContact = latestRecord.Authorisers.find(
            (ogContact: any) => (ogContact && contact.Phone === ogContact.Phone)
          );
          return matchingContact?.AuthoriserID
            ? {...matchingContact, ...contact, AuthoriserID: Number(matchingContact.AuthoriserID)}
            : { ...matchingContact, ...contact };
        });
      }
      let updatedRecord = {
        ...latestRecord,
        Authorisers: currentContacts
      };
      Object.assign(currentSettlors[0], updatedRecord);
      this.tabControlService.updateRecord(2, currentSettlors);
    }
    fields.push(this.createAuthorisersGroup());
    this.getSettlorFormGroup().setControl('Authorisers', fields);
  }

  async removeAuthoriser(j: number) {
    const fields = this.getAuthorisers();
    fields.removeAt(j);

    let currentAuthorisers = fields.getRawValue();

    if (currentAuthorisers.length > 0) {
      const currentSettlors = this.settlors;
      let latestRecord = currentSettlors[0];

      if (latestRecord.Authorisers?.length > 0) {
        currentAuthorisers = currentAuthorisers.map((contact: any) => {
          let matchingContact = latestRecord.Authorisers.find(
            (ogContact: any) => (ogContact && contact.Phone === ogContact.Phone)
          );
          return matchingContact?.AuthoriserID
            ? {...matchingContact, ...contact, AuthoriserID: Number(matchingContact.AuthoriserID)}
            : { ...matchingContact, ...contact };
        });
      }
      let updatedRecord = {
        ...latestRecord,
        Authorisers: currentAuthorisers
      };
      Object.assign(currentSettlors[0], updatedRecord);
      this.tabControlService.updateRecord(2, currentSettlors);
    }
  }

  getAuthorisers() : FormArray {
    return this.getSettlors()?.at(0)?.get('Authorisers') as FormArray;  
  }
  getAuthorisersFormGroup(index: number): FormGroup {
    return this.getAuthorisers().at(index) as FormGroup;
  }

  getPrincipalFormGroup(index: number): FormGroup {
    const settlorsArray = this.getSettlorFormGroup(index);
    return settlorsArray.get('Principal') as FormGroup;
  }

  showSettlorForm(): void {
    if (!this.settlorFormVisible) {
      this.settlorFormVisible = true;
      this.populateForm(true);

      if (this.settlorType === 0) {
        this.institutionPanels[0] = this.generatePanelsForInstitutions();
        this.institutionForm.updateValueAndValidity();
      } else {
        this.getSettlors().controls.forEach((_, i) => {
          if (!this.individualPanels[i]) {
              this.individualPanels[i] = this.generatePanelsForIndividuals(i);
            }
        });
        this.individualForm.updateValueAndValidity();
      }
    }
    
  }

  onOptionChange(value: boolean): void {
    this.isSettlorOrganization = value;
    if (this.isSettlorOrganization) {
      this.tabControlService.settlorType = 0;
    } else {
      this.tabControlService.settlorType = 1;
    }

    try {
      if (this.settlors.length > 0) {
        if (this.settlors[0]?.SettlorID) {
          // Add settlors from storage
          if (this.settlorType == 1) {
            this.addSettlorsArray(this.settlors[0]);
            this.settlors.forEach((settlor: any, index: number) => {
              if (index > 0 && settlor?.SettlorID) this.addSettlorsArray(settlor);
            });
          } else {
            this.addSettlorsArray(this.settlors[0]);
          }

        } else {
          this.tabControlService.refreshRecord(2);
          this.addSettlorsArray();
        }
      } else {
        this.addSettlorsArray();
      }

      if (this.settlorType == 1) {
        this.settlors.forEach((settlor: any, i: number) => {
          this.updateIndividualDoneStatus(i, settlor);
        });
      } else {
        this.updateInstitutionDoneStatus(this.settlors[0]);
      }

    } catch (error) { console.error('onOptionChange : ', error) }
  }

  skipAddPrincipal(): void {
    let currentSettlors = this.tabControlService.settlors;
    let currentRecord = currentSettlors[currentSettlors.length-1];
    currentRecord.done = true;

    Object.assign(currentSettlors[currentSettlors.length - 1], currentRecord);
    this.tabControlService.updateRecord(2, currentSettlors);
  }

  ondesceasedChange(value: boolean): void {
    this.addDesceased = value;

    if (value) {
      this.getSettlorFormGroup(0).get('Principal')?.get('FirstName')?.addValidators([Validators.required]);
      this.getSettlorFormGroup(0).get('Principal')?.get('LastName')?.addValidators([Validators.required]);
      this.getSettlorFormGroup(0).get('Principal')?.get('DeathCertImage')?.addValidators([Validators.required]);
    } else {
      // Clear form control values
      this.getSettlorFormGroup(0).get('Principal')?.get('FirstName')?.setValue('');
      this.getSettlorFormGroup(0).get('Principal')?.get('MiddleName')?.setValue('');
      this.getSettlorFormGroup(0).get('Principal')?.get('LastName')?.setValue('');
      this.getSettlorFormGroup(0).get('Principal')?.get('DeathCertImage')?.setValue('');

      this.getSettlorFormGroup(0).get('Principal')?.get('FirstName')?.setErrors(null);
      this.getSettlorFormGroup(0).get('Principal')?.get('LastName')?.setErrors(null);
      this.getSettlorFormGroup(0).get('Principal')?.get('DeathCertImage')?.setErrors(null);

      this.getSettlorFormGroup(0).get('Principal')?.get('FirstName')?.setValidators(null);
      this.getSettlorFormGroup(0).get('Principal')?.get('LastName')?.setValidators(null);
      this.getSettlorFormGroup(0).get('Principal')?.get('DeathCertImage')?.setValidators(null);

      // Clear validators
      this.getSettlorFormGroup(0).get('Principal')?.get('FirstName')?.clearValidators();
      this.getSettlorFormGroup(0).get('Principal')?.get('LastName')?.clearValidators();
      this.getSettlorFormGroup(0).get('Principal')?.get('DeathCertImage')?.clearValidators();
    }

    // Reset validation status
    this.getSettlorFormGroup(0).get('Principal')?.updateValueAndValidity();
    this.institutionForm.updateValueAndValidity();
  }

  async openOtpModal(index?: number, authoriserIndex?:number) {
    this.loadingText = 'Requesting OTP';
    this.loading = true;
    this.notificationService.isLoading(true);

    try {
      const records = this.tabControlService.settlorType == 0 ?
        this.institutionForm.controls['settlors'].getRawValue() : this.individualForm.controls['settlors'].getRawValue();
      const recordIndex = index ?? records.length-1;

      const auths = records[recordIndex].Authorisers;
      const authIndex = authoriserIndex ?? (auths ? auths.length-1 : 0);

      let data = {
        Region: this.region,
        FirstName: records[recordIndex].FirstName,
        LastName: records[recordIndex].LastName,
        Phone: records[recordIndex].Phone,
        Email: records[recordIndex].Email
      };

      if (this.tabControlService.settlorType == 0) {
        data = {
          Region: this.region,
          FirstName: auths[authIndex].FirstName,
          LastName: auths[authIndex].LastName,
          Phone: auths[authIndex].Phone,
          Email: auths[authIndex].Email
        };

        this.tabControlService.OTPMessage = 'In order to proceed, please enter the One Time Password (OTP) sent to the Authoriser\'s email and phone';
      } else {
        this.tabControlService.OTPMessage = 'In order to proceed, please enter the One Time Password (OTP) sent to the Settlor\'s email and phone';
      }

      let savedTime = this.tabControlService.OTPRequestStats;
      let response = {Status: 0, Message: 'Initialized'};

      this.tabControlService.OTPValid = checkTime(savedTime.time);

      if (this.tabControlService.OTPValid && savedTime.phone === data.Phone) {
        response.Status = 1;
        response.Message = 'Current OTP is still Valid';

      } else {
        response = await this.apiService.postRequest(
          environment.baseUrl + Constants.otpRequestURL, data);
      }

      if (response.Status === 1) {
        let currentSettlors = this.tabControlService.settlors;
        let currentRecord = currentSettlors[recordIndex];
        let otpVerified = false;

        // remove images from record to NOT replace object images!!!
        const recordValueWithoutImages = Object.fromEntries(
          Object.entries(records[recordIndex]).filter(([key]) => !key.includes('Image'))
        );
        currentRecord = {...currentRecord, ...recordValueWithoutImages};
        
        if (this.settlorType == 0) {
          let currentAuthorisers = currentRecord.Authorisers;
          let currentAuthoriser = currentAuthorisers[authIndex];
          currentAuthoriser = {
            ...currentAuthoriser,
            ...records[recordIndex].Authorisers[authIndex]
          };

          Object.assign(currentAuthorisers[authIndex], currentAuthoriser);
          currentRecord.Authorisers = currentAuthorisers;
        }
        
        Object.assign(currentSettlors[recordIndex], currentRecord);
        this.tabControlService.updateRecord(2, currentSettlors);
        
        if (this.tabControlService.OTPValid) {
          this.notificationService.viewToast(
            'info',
            `Please enter the OTP that was sent to your ${this.region === 1 ? 'Email' : 'Phone / Email'}` );
        } else {
          const timeStats = {time: Date.now() / 1000, phone: data.Phone};
          this.tabControlService.OTPRequestStats = timeStats;
          this.tabControlService.OTPValid = true;

          if (this.region == 1) { // Diaspora
            this.notificationService.viewToast(
              'success',
              `OTP sent to ${data.Email}.`);
          } else {
            this.notificationService.viewToast(
              'success',
              `OTP sent to ${data.Phone}.`,
              'We have also sent it to the provided Email');
          }

        }

        this.tabControlService.OTPRequestPage = 'Settlor';
        this.tabControlService.OTPIndex = recordIndex;
        if (this.settlorType == 0) this.tabControlService.OTPIndex = authIndex;
        
        this.loadingText = 'Verify Details';

        const dialogRef = this.dialog.open(OtpPopupComponent, {
          disableClose: true,
        });
    
        dialogRef.componentInstance.otpVerified.subscribe((value: boolean) => {
          otpVerified = value;
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (otpVerified) {
            if (this.settlorType == 0) {
              let currentAuthorisers = currentRecord.Authorisers;
              for (const element of currentAuthorisers) {
                let currentAuthoriser = element;
                currentAuthoriser.verified = true;
                Object.assign(element, currentAuthoriser);
              }
              currentRecord.Authorisers = currentAuthorisers;
              Object.assign(currentSettlors[recordIndex], currentRecord);
              this.tabControlService.updateRecord(2, currentSettlors);
            } else {
              Object.assign(currentSettlors[recordIndex], currentRecord);
              this.tabControlService.updateRecord(2, currentSettlors); 
              this.saveSettlor(recordIndex);
            }

          } else {
            this.notificationService.viewToast('warning', 'Please verify your details to proceed');
          }
        });
      } else {
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.error(':: OTP Modal : ', error);
      this.notificationService.viewToast('error', 'OTP request failed');
    }
    this.notificationService.isLoading(false);
    this.loading = false;
  }

  async saveSettlor(index: number): Promise<void> {
    if (this.settlors[index].verified || this.settlors[index].infoDone)
      this.loadingText = 'Updating Settlor';
    else this.loadingText = 'Saving Settlor';

    let tsMessage = this.addText;
    this.notificationService.isLoading(true);

    try {
      let temp = this.getSettlorFormGroup(index).getRawValue();

      let category;
      if (this.tabControlService.TrustID === null || index === 0) {
        category = 'Primary Settler';
      } else {
        category = 'Secondary Settler';
      }
      
      let data = {
        ...temp,
        ...{
          SecondaryPhone: this.tabControlService.basicData.SecondaryPhone || '',
          TrustID: this.tabControlService.TrustID,
          Category: category,
          SettlorType: this.settlorType == 0 ? 'Institution' : 'Individual'
        }
      };

      let currentSettlors = this.settlors;
      
      // Setup docs
      if (this.settlors[index].SettlorID && this.settlors[index].verified || this.settlors[index].authDone) {
        data.IDNoImage = this.settlors[index].IDNoImage;
        data.KraPinImage = this.settlors[index].KraPinImage;
      } else {
        data.IDNoImage = {name: '', stringValue: ''};
        data.KraPinImage = {name: '', stringValue: ''};
      }
      // setup Authorisers
      if (this.tabControlService.settlorType === 0) {
        if (currentSettlors[index].docsDone === true) {  
          data.Principal.DeathCertImage = this.deathObject;
        }
        
        if (this.settlors[index].authDone && data.Authorisers) {
          if (!Array.isArray(data.Authorisers)) data.Authorisers = [data.Authorisers];
          
          if (this.settlors[index].Authorisers?.length > 0) {
            data.Authorisers = data.Authorisers.map((contact: any) => {
              const matchingAuth = this.settlors[index].Authorisers.find(
                (ogAuth: any) => (ogAuth?.ContactID && contact.Phone === ogAuth.Phone)
              );
              return matchingAuth 
                ? {...contact, ContactID: Number(matchingAuth.ContactID)}
                : contact;
            });
          }
          
        } else {
          data.Authorisers = [];
        }
      } else {
        data.Authorisers = [];
      }

      if (currentSettlors[index].SettlorID) {
        data = {...data, SettlorID: currentSettlors[index].SettlorID};
      }
      
      const response = await this.apiService.postRequest(
        environment.baseUrl + Constants.saveSettlorURL, data, false);
      
      if (response.Status === 1) {
        if (this.tabControlService.TrustID === null) {
          this.tabControlService.TrustID = response.TrustID;
          this.tabControlService.updateTrustProgress('Settlors');
        }

        let currentSettlors = this.settlors;
        const latestRecord = currentSettlors[index];
        let currentAuthorisers = latestRecord.Authorisers;
        // remove images from record to NOT replace object images!!!
        const recordValueWithoutImages = Object.fromEntries(
          Object.entries(temp).filter(([key]) => !key.includes('Image'))
        );
        let updatedRecord = {
          ...latestRecord, 
          ...recordValueWithoutImages,
          SettlorID: response.SettlorID, Category: category
        };

        if (this.settlorType == 0) {
          updatedRecord.Authorisers = currentAuthorisers;
        }
        Object.assign(currentSettlors[index], updatedRecord);

        await this.tabControlService.updateRecord(2, currentSettlors);
        
        currentSettlors = this.tabControlService.settlors;
        let currentRecord = currentSettlors[index];

        if (this.settlors[index]?.IDNoImage?.stringValue?.length > 5 && (this.settlors[index].verified || this.settlors[index].authDone)) {
          tsMessage = this.updateText;
          
          if (response.IdURL) {
            this.tabControlService.removeFromDocSummary('ID', 'Settlor', currentRecord.SettlorID);
            this.tabControlService.updateDocSummary(response.IdURL);
            currentRecord = {...currentRecord, IDURL: response.IdURL, SavedID: currentRecord.IDNoImage};
          }
          if (response.KraURL) {
            this.tabControlService.removeFromDocSummary('PIN', 'Settlor', currentRecord.SettlorID);
            this.tabControlService.updateDocSummary(response.KraURL);
            currentRecord = {...currentRecord, KraURL: response.KraURL, SavedPIN: currentRecord.KraPinImage};
          }
          
          if (this.tabControlService.settlorType == 0) { // Settlor is institution
            currentRecord.docsDone = true;

          } else {
            currentRecord.done = true;
          }

          Object.assign(currentSettlors[index], currentRecord);
          await this.tabControlService.updateRecord(2, currentSettlors);
        } else {
          if (this.tabControlService.settlorType == 0) { // Settlor is institution
            if (currentRecord.infoDone) {
              tsMessage = this.updateText;

              if (currentRecord.authDone) {
                if (!currentRecord.done) {
                  if (response.DeathCertURL) {
                    this.tabControlService.removeFromDocSummary('PRINCIPAL_DEATHCERT', 'Settlor', currentRecord.SettlorID)
                    this.tabControlService.updateDocSummary(response.DeathCertURL);

                    let principal = currentRecord.Principal;
                    principal = {...principal, ...{DeathCertURL: response.DeathCertURL}};
                    currentRecord.Principal = principal;
                  }

                  currentRecord.done = true;
                }
              } else {
                currentRecord.authDone = true;
                this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(index).get('IDNoImage')!);
                this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(index).get('KraPinImage')!);
                this.getSettlorFormGroup(index).get('IDNoImage')?.updateValueAndValidity();
                this.getSettlorFormGroup(index).get('KraPinImage')?.updateValueAndValidity();
              }
            } else {
              currentRecord.infoDone = true;
              try {
                this.validationService.addOrRemoveValidator(
                  true,
                  this.getAuthorisersFormGroup(0).get('FirstName')!
                );
                this.validationService.addOrRemoveValidator(
                  true,
                  this.getAuthorisersFormGroup(0).get('LastName')!
                );
                
                this.validationService.addOrRemoveOneValidator(
                  true,
                  this.getAuthorisersFormGroup(0).get('Phone')!,
                  Validators.required
                );
      
                this.validationService.addOrRemoveSpecificValidators(
                  true,
                  this.getAuthorisersFormGroup(0).get('Email')!,
                  [
                    Validators.required,
                    Validators.email]
                );
              } catch (error) { }
            }  

          } else {
            currentRecord.verified = true;
            this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(index).get('IDNoImage')!);
            this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(index).get('KraPinImage')!);
          }
          
          Object.assign(currentSettlors[index], currentRecord);
          await this.tabControlService.updateRecord(2, currentSettlors);
        }

        this.notificationService.viewToast('success', tsMessage);
        if (this.settlorType == 0) this.updateInstitutionDoneStatus(currentRecord);
        else this.updateIndividualDoneStatus(index, currentRecord);
        if (!environment.production) console.log('>> New Settlors !! \n', this.tabControlService.settlors);

      } else {
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.error(':: Save Settlor : ', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    }
    this.notificationService.isLoading(false);
    this.loading = false;
  }

  // ==============  EXPANSION SECTION   =================
  @ViewChild('settlorInfo') settlorInfo!: TemplateRef<any>;
  @ViewChild('uploadDocsIndividual') uploadDocsIndividual!: TemplateRef<any>;
  
  @ViewChild('institutionInfo') institutionInfo!: TemplateRef<any>;
  @ViewChild('authoriserInfo') authoriserInfo!: TemplateRef<any>;
  @ViewChild('uploadDocs') uploadDocs!: TemplateRef<any>;
  @ViewChild('princInfo') princInfo!: TemplateRef<any>;


  // Panels
  generatePanelsForIndividuals = (i: number): ExpansionPanel[] => {
    // Fallback if templates not ready
    if (!this.settlorInfo || !this.uploadDocsIndividual || this.settlors?.length == 0 || !this.settlors[i]) {
      return [];
    }
    return [
      {
        title: 'Personal Information',
        contentTemplate: this.settlorInfo,
        context: { index: i },
        expanded: (i== 0 ? !this.settlors[i].SettlorID : !this.settlors[i].verified),
        done: (i== 0 ? this.settlors[i].SettlorID : this.settlors[i].verified)
      },
      {
        title: 'Upload Documents',
        contentTemplate: this.uploadDocsIndividual,
        context: { index: i },
        disabled: (i== 0 ? !this.settlors[i].SettlorID : !this.settlors[i].verified ),
        expanded: (!this.settlors[i].done && (i== 0 ? this.settlors[i].SettlorID : this.settlors[i].verified) ),
        done: this.settlors[i].done
      }
    ];
  }
  generatePanelsForInstitutions = (): ExpansionPanel[] => {
    // Fallback if templates not ready
    if (!this.institutionInfo || !this.authoriserInfo || !this.uploadDocs || !this.princInfo || this.settlors?.length == 0) {
      return [];
    }
    return [
      {
        title: 'Institution Information',
        contentTemplate: this.institutionInfo,
        context: { index: 0 },
        expanded: !(this.settlors[0].infoDone),
        done: (this.settlors[0].infoDone)
      },
      {
        title: 'Institution Authorisers',
        contentTemplate: this.authoriserInfo,
        context: { index: 0 },
        disabled: !(this.settlors[0].infoDone),
        expanded: (this.settlors[0].infoDone),
        done: (this.settlors[0].authDone)
      },
      {
        title: 'Upload Documents',
        contentTemplate: this.uploadDocs,
        context: { index: 0 },
        disabled: !(this.settlors[0].authDone),
        expanded: (this.settlors[0].authDone),
        done: (this.settlors[0].docsDone)
      },
      {
        title: 'Principal Member',
        contentTemplate: this.princInfo,
        context: { index: 0 },
        disabled: !(this.settlors[0].docsDone),
        expanded: (this.settlors[0].docsDone),
        done: (this.settlors[0].done)
      }
    ];
  }
  // Done Status updates
  updateIndividualDoneStatus(i: number, value: any) {
    // Ensure panels array exists
    this.individualPanels = this.individualPanels || [];
    
    // Initialize if missing or invalid
    if (this.individualPanels[i]?.length !== 3) {
      this.individualPanels[i] = this.generatePanelsForIndividuals(i);
    }

    const panels = this.individualPanels[i];
    const panel1Done = i== 0 ? this.settlors[i].SettlorID : value.verified;

    // Update panel states while preserving context
    if (panels[0]) {
      panels[0].done = panel1Done;
      // Preserve existing context or initialize if missing
      panels[0].context = panels[0].context || { index: i };
      panels[0].expanded = !panel1Done;
    }
    
    if (panels[1]) {
      panels[1].done = value.done;
      panels[1].context = panels[1].context || { index: i };
      panels[1].disabled = !panel1Done;
      panels[1].expanded = panel1Done && !value.done;
    }

    setTimeout(()=> {
      try {
        if (value.SettlorID && !value.done && i == this.settlors.length-1 ) {
          this.notificationService.viewToast(
            'info',
            `Settlor ${value.FirstName} ${value.LastName}`,
            `Please continue to ${panels[1].title}`
          );
        }
        
      } catch (error) {}
      
    })
  }
  updateInstitutionDoneStatus(value: any) {
    // Ensure panels array exists
    this.institutionPanels = this.institutionPanels || [];
    
    // Initialize if missing or invalid
    if (this.institutionPanels[0]?.length !== 4) {
      this.institutionPanels[0] = this.generatePanelsForInstitutions();
    }

    const panels = this.institutionPanels[0];
    
    // Update panel states while preserving context
    if (panels[0]) {
      panels[0].done = value.infoDone;
      // Preserve existing context or initialize if missing
      panels[0].context = panels[0].context || { index: 0 };
      panels[0].expanded = !value.infoDone;
    }
    
    if (panels[1]) {
      panels[1].done = value.authDone;
      panels[1].context = panels[1].context || { index: 0 };
      panels[1].disabled = !value.infoDone;
      panels[1].expanded = !value.authDone;
    }
    if (panels[2]) {
      panels[2].done = value.docsDone;
      panels[2].context = panels[2].context || { index: 0 };
      panels[2].disabled = !value.authDone;
      panels[2].expanded = !value.docsDone;
    }
    if (panels[3]) {
      panels[3].done = value.done;
      panels[3].context = panels[3].context || { index: 0 };
      panels[3].disabled = !value.docsDone;
      panels[3].expanded = !value.done;
    }

    setTimeout(()=> {
      try {
        if (value.SettlorID && !value.done) {
          this.notificationService.viewToast(
            'info',
            `Institution ${value.InstitutionName}`,
            `Please continue to ${
              value.docsDone ? panels[3].title :
              value.authDone ? panels[2].title : panels[1].title }`
          );
        }
        
      } catch (error) {}
      
    })
  }
  //  Form Change Listeners
  private setupFormChangeListeners() {
    this.cleanupFormChangeListeners();
    
    this.getSettlors().controls.forEach((control, index) => {
      // General form changes
      const subscription = (control as FormGroup).valueChanges.subscribe(() => {
        this.cdr.detectChanges();
      });
      this.formChangesSubscription.push(subscription);
    });
  }
  private setupFormChangeListenersForIndex(index: number) {
    // Clean up existing subscription if any
    const existingSub = this.formChangesSubscription[index];
    if (existingSub) {
      existingSub.unsubscribe();
    }
  }
  private cleanupFormChangeListeners() {
    this.formChangesSubscription.forEach(sub => sub.unsubscribe());
    this.formChangesSubscription = [];
  }


  private readonly loggedErrors = new Set<string>();

  confirmValidationStatus(index: number): boolean {
    if (this.basicData?.FirstName && this.basicData.LastName && this.basicData.Phone && this.basicData.Email && this.basicData.IDNo) {  
      let isCaptured = false;
      let isMatching = false;

      if (this.settlorType == 0) {
        isMatching = this.basicData.FirstName === this.getAuthorisersFormGroup(0).get('FirstName')?.value
          && this.basicData.LastName === this.getAuthorisersFormGroup(0).get('LastName')?.value
          && this.basicData.Phone === this.getAuthorisersFormGroup(0).get('Phone')?.value
          && this.basicData.Email === this.getAuthorisersFormGroup(0).get('Email')?.value
          && this.basicData.IDNo.toString() === this.getAuthorisersFormGroup(0).get('IDNo')?.value?.toString();

        isCaptured = this.settlors[index].authDone;
      } else {
        isMatching = this.basicData.FirstName === this.getSettlorFormGroup(index).get('FirstName')?.value
          && this.basicData.LastName === this.getSettlorFormGroup(index).get('LastName')?.value
          && this.basicData.Phone === this.getSettlorFormGroup(index).get('Phone')?.value
          && this.basicData.Email === this.getSettlorFormGroup(index).get('Email')?.value
          && this.basicData.IDNo.toString() === this.getSettlorFormGroup(index).get('IDNo')?.value?.toString();

        isCaptured = this.settlors[index].verified;
      }
      
      return isCaptured && isMatching;
    } else {
      return false;
    }
  }

  confirmFormMatchesRecord(index: number): boolean {
    try {
      const settlor = this.settlors[index];
      const formGroup = this.getSettlorFormGroup(index);
      
      if (!settlor || !formGroup) {
        const errorKey = `missing-data-${index}`;
        if (!this.loggedErrors.has(errorKey)) {
          console.debug('Settlor or formGroup not found at index', index);
          this.loggedErrors.add(errorKey);
        }
        return true;
      }

      // For new settlors that haven't been saved yet
      if (!settlor.SettlorID && !settlor.done && !settlor.verified) {
        const errorKey = `new-unsaved-${index}`;
        if (!this.loggedErrors.has(errorKey)) {
          console.debug('New unsaved settlor at index', index);
          this.loggedErrors.add(errorKey);
        }
        return true;
      }

      // Compare all relevant fields
      const fieldsToCompare = this.tabControlService.settlorType == 1 
        ? ['Title', 'FirstName', 'MiddleName', 'LastName', 'Gender', 'Nationality',
            'Phone', 'Email', 'Address', 'City', 'IDNo', 'KraPin', 'Country', 'County', 'Occupation']
        : ['InstitutionName', 'BusinessNature', 'Phone', 'Email', 'Address'];

      // Track mismatches for debugging
      const mismatches: {field: string, formValue: any, recordValue: any}[] = [];

      const basicFieldsMatch = fieldsToCompare.every(field => {
        const formValue = formGroup.get(field)?.value;
        const recordValue = settlor[field];
        const valuesMatch = (formValue || '') === (recordValue || '');
        
        if (!valuesMatch) {
          mismatches.push({
            field,
            formValue,
            recordValue
          });
        }
        return valuesMatch;
      });

      // Check file fields
      const fileMismatches: {field: string, formValue: any, recordValue: any, matches: boolean}[] = [];
      const idMatches = settlor.IDNoImage.name === settlor.SavedID.name;
      const kraMatches = settlor.KraPinImage.name === settlor.SavedPIN.name;
      
      const filesMatch = idMatches && kraMatches;

      if (!filesMatch) {
        fileMismatches.push({
          field: 'IDNoImage',
          formValue: settlor.IDNoImage.name,
          recordValue: settlor.SavedID.name,
          matches: idMatches
        }, {
          field: 'KraPinImage',
          formValue: settlor.KraPinImage.name,
          recordValue: settlor.SavedPIN.name,
          matches: kraMatches
        });
      }

      // Log mismatches only if they exist and in debug mode
      if ((mismatches.length > 0 || fileMismatches.length > 0) && !environment.production) {
        const mismatchKey = `mismatch-${index}-${JSON.stringify(mismatches)}-${JSON.stringify(fileMismatches)}`;
        if (!this.loggedErrors.has(mismatchKey)) {
          console.groupCollapsed(`Form mismatch for settlor ${(index+1)}`);
          if (mismatches.length > 0) {
            console.log('Field mismatches:', mismatches);
          }
          if (fileMismatches.length > 0) {
            console.log('File mismatches:', fileMismatches);
          }
          console.groupEnd();
          this.loggedErrors.add(mismatchKey);
        }
      }

      return basicFieldsMatch && filesMatch;
    } catch (error: any) {
      const errorKey = `error-${index}-${error.message}`;
      if (!this.loggedErrors.has(errorKey)) {
        console.error('Error in confirmFormMatchesRecord:', error);
        this.loggedErrors.add(errorKey);
      }
      return false;
    }
  }
  /**
   * Checks if any form group in the settlors array doesn't match its corresponding record
   * @returns boolean - true if ALL forms match their records, false if ANY form doesn't match
   */
  checkAllFormsMatchRecords(): boolean {
    // If no settlors exist, return true (no mismatches)
    if (!this.settlors || this.settlors.length === 0) {
      return true;
    }

    // Check each settlor form
    for (let i = 0; i < this.settlors.length; i++) {
      if (!this.confirmFormMatchesRecord(i)) {
        // Log which index failed (for debugging)
        console.debug(`Form at index ${i} doesn't match record`, {
          settlor: this.settlors[i],
          formValues: this.getSettlorFormGroup(i).getRawValue()
        });
        return false;
      }
    }

    return true;
  }

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++

  async updateRecord(index: number) {
    await this.saveSettlor(index);
  }

  async updateProgress(): Promise<void> {
    if (!this.settlors[this.settlors.length-1].done ) {
      await this.saveSettlor(this.getSettlors().length-1);
    }
    this.saveProgress();
  }

  async submitForm(): Promise<void> {
    if (this.settlors[this.settlors.length-1].done) {
      if (this.settlorType == 0) {
        if (this.confirmFormMatchesRecord(0)) this.navigateFunction();
        else this.saveSettlor(this.getSettlors().length-1)
      } else this.navigateFunction();
    } else {
      if (this.tabControlService.settlorType == 0) {
        if (this.settlors[this.settlors.length-1].infoDone && !this.settlors[this.settlors.length-1].authDone) {
          const latestSettlors = this.settlors[this.settlors.length-1];
          if (latestSettlors.Authorisers[latestSettlors.Authorisers.length-1].verified) {
            await this.saveSettlor(this.getSettlors().length-1);
          } else await this.openOtpModal(0, latestSettlors.Authorisers.length-1);

        } else {
          await this.saveSettlor(this.getSettlors().length-1);
        }

      } else {
        if (this.getSettlors().length === 1) {
          await this.saveSettlor(this.getSettlors().length-1);
        } else {
          if (this.settlors[this.settlors.length-1].verified) await this.saveSettlor(this.getSettlors().length-1);
          else this.openOtpModal();
        }
      }
    }
  }

  async navigateFunction(): Promise<void> {
    await this.tabControlService.changeTab(3);
    this.tabControlService.page2Done = true;
  }

  returnIndividualNavigationText(): string {
    if (this.loading) return this.loadingText;
    const latestSettlor = this.settlors[this.settlors.length-1];
    let buttonString = 'Save Details';

    if (latestSettlor.done) buttonString = 'Next';
    else {
      if (this.settlors.length-1 == 0 || latestSettlor.verified) buttonString = 'Save Details';
      else buttonString = 'Verify via OTP';
    }
    return buttonString;
  }

  returnInstitutionNavigationText(): string {
    if (this.loading) return this.loadingText;
    const latestSettlor = this.settlors[0];
    let buttonString = 'Save Details';
    
    if (latestSettlor?.done) buttonString = 'Next';
    else {
      if (latestSettlor?.docsDone) {
          if (this.addDesceased) buttonString = 'Save Details';
          else buttonString = 'Skip';
        } else {
          if (latestSettlor?.authDone) buttonString = 'Upload Documents';
          else {
            if (latestSettlor?.infoDone) {
              try {
                if (latestSettlor.Authorisers[latestSettlor.Authorisers.length-1]?.verified) {
                  buttonString = 'Save Details';
                } else buttonString = 'Verify via OTP';
              } catch (error) {
                console.error('[returnInstitutionNavigationText] ', error);
                buttonString = 'Verify via OTP';
              }
            }
          }
        }
    }

    return buttonString;
  } 
}
